import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef, useLayoutEffect } from 'react';
import Button from '@mui/material/Button';
import { COLORS } from '../../constants/theme';
const collapsedOverlay = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'center',
    zIndex: 2,
    position: 'absolute',
    bottom: 0,
    height: '140px',
    width: '100%',
    borderBottom: '1px solid var(--border-color)',
    borderLeft: '1px solid var(--border-color)',
    borderRight: '1px solid var(--border-color)',
    maskImage: 'initial',
};
const CollapseContent = (props) => {
    const { children, maxHeight } = props;
    const [contentHeight, setContentHeight] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const collapseContainerRef = useRef(null);
    const contentStyle = {
        maxHeight,
        overflowY: 'clip',
        position: 'relative',
    };
    useLayoutEffect(() => {
        if (collapseContainerRef.current) {
            const children = collapseContainerRef.current.children;
            // measure the height of the first child
            setContentHeight(children[0].getBoundingClientRect().height);
        }
    }, []);
    const renderContent = () => {
        // only collapse if content is greater than X pixels
        if (contentHeight != null && contentHeight > maxHeight) {
            if (!isOpen) {
                const style = Object.assign(Object.assign({}, contentStyle), { maskImage: 'linear-gradient(to bottom, black 50%, transparent 100%)' });
                return (_jsxs("div", { style: Object.assign({ position: 'relative', width: '100%', overflowX: 'hidden' }, props.style), children: [_jsx("div", { className: props.className, style: style, ref: collapseContainerRef, children: children }), _jsx("div", { style: Object.assign({}, collapsedOverlay), children: _jsx(Button, { style: { color: COLORS.WHITE }, onClick: () => {
                                    setIsOpen(true);
                                }, children: "Show All" }) })] }));
            }
            else {
                return (_jsxs("div", { style: Object.assign({ width: '100%', overflowX: 'hidden' }, props.style), children: [_jsx("div", { className: props.className, ref: collapseContainerRef, children: children }), _jsx("div", { style: { display: 'flex', justifyContent: 'center', width: '100%' }, children: _jsx(Button, { style: { color: COLORS.WHITE }, onClick: () => {
                                    setIsOpen(false);
                                }, children: "Show Less" }) })] }));
            }
        }
        else {
            return (_jsx("div", { className: props.className, ref: collapseContainerRef, style: props.style, children: children }));
        }
    };
    return _jsx(_Fragment, { children: renderContent() });
};
export default CollapseContent;
//# sourceMappingURL=CollapsibleContent.js.map